import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { LoadingScreen } from "./components/LoadingScreen";
import { useSession } from "./lib/session";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Sell } from "./pages/Sell";
import { Transactions } from "./pages/Transactions";
import { Wallet } from "./pages/Wallet";
import { Statements } from "./pages/Statements";
import { Reports } from "./pages/Reports";
import { Profile } from "./pages/Profile";
import { Support } from "./pages/Support";
import { Help } from "./pages/Help";

function Protected({ children }: { children: React.ReactNode }) {
  const { authenticated, loading } = useSession();
  if (loading) return <LoadingScreen />;
  if (!authenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function NotFound() {
  return (
    <div className="ev-empty" style={{ minHeight: 360 }}>
      <strong className="ev-h3">Page not found</strong>
      <p className="ev-caption">The page you were looking for has moved or never existed.</p>
      <a className="ev-btn ev-btn-sm ev-btn-secondary" href="/">Back to overview</a>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <AppShell />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="sell" element={<Sell />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="wallet" element={<Wallet />} />
        <Route path="statements" element={<Statements />} />
        <Route path="reports" element={<Reports />} />
        <Route path="profile" element={<Profile />} />
        <Route path="support" element={<Support />} />
        <Route path="help" element={<Help />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
